import React from 'react';
import Router from './config/Router/Router';
import StoreProvider from './config/StoreProvider/StoreProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ToastContainer } from 'react-toastify';

const App = () => {
  return (
    <GoogleOAuthProvider clientId="886565191714-utk2njsbdi4v0ba5rhuu0gae561cnqja.apps.googleusercontent.com">
      <StoreProvider>
        <Router />
        <ToastContainer />
      </StoreProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
